import { CheckOutlineIcon } from './CheckOutlineIcon';

/**
 * author: Google
 * id 38BFE155-0352-4907-A578-B5D0D7F5B78D
 * name check-outline
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/check-outline.svg
 * tags
 */
export const SucessOutlineIcon = CheckOutlineIcon;
export default SucessOutlineIcon